"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var Constants = /** @class */ (function () {
    function Constants() {
    }
    /* Max # of levels in Hierarchy UI */
    Constants.LEVEL = 16;
    Constants.ORPHAN_PLACEHOLDER_ID = 'orphanPlaceHolder';
    Constants.HIERARCHY_MENU_ID = 'Hierarchy-Menu-Id';
    return Constants;
}());
exports.Constants = Constants;
